const endpoints = {
	setApprovalCheck: '/approval_checks/setApprovalCheck',
}
export {endpoints}